import PropTypes from "prop-types";
import React from "react";
import Heading from "../../elements/heading";
import ListContentItem from "../../react-components/list-content-item";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";

import "./style.scss";

const HeroSupport = ({ rendering, fields }) => {
  const {
    headingType,
    headingBody,
    body,
    items = [],
    mobileStackDirection = { fields: { phrase: { value: "vertical" } } },
    backgroundImage,
    paddingAboveTop,
    paddingAboveBottom
  } = fields;
  let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
    bottom = paddingAboveBottom
      ? paddingAboveBottom.fields.phrase.value
      : "default";
  const backgroundStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.396) 37.43%, rgba(0, 0, 0, 0.99) 100%), url(${backgroundImage.value.src})`
  };

  const heroSupportClasses = classNames(
    "hero-support",
    "grid",
    `padding-bottom-${top}`,
    `padding-top-${bottom}`
  );
  const listContentClasses = classNames(
    "hero-support-list-content",
    mobileStackDirection.fields.phrase.value
  );
  return (
    <section
      className={heroSupportClasses}
      style={backgroundStyle}
      datasourceid={rendering.dataSource}
    >
      <Heading
        {...{
          type: headingType,
          html: headingBody
        }}
        className="title"
        typographyClass="type-h1"
      />

      {body && <RichText tag="p" className="body" field={body} />}

      <div className={listContentClasses}>
        {items.map((item, index) => (
          <ListContentItem {...{ ...item, index: index }} key={index} />
        ))}
      </div>
    </section>
  );
};

HeroSupport.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    headingType: PropTypes.object,
    headingBody: PropTypes.object,
    body: PropTypes.shape({ value: PropTypes.string }),
    items: PropTypes.array,
    mobileStackDirection: PropTypes.shape({
      fields: PropTypes.shape({
        phrase: PropTypes.shape({
          value: PropTypes.oneOf(["vertical", "horizontal"])
        })
      })
    }),
    backgroundImage: PropTypes.object,
    paddingAboveTop: PropTypes.shape({
      fields: PropTypes.shape({
        phrase: PropTypes.shape({
          value: PropTypes.oneOf(["default", "small", "tiny"])
        })
      })
    }),
    paddingAboveBottom: PropTypes.shape({
      fields: PropTypes.shape({
        phrase: PropTypes.shape({
          value: PropTypes.oneOf(["default", "small", "tiny"])
        })
      })
    })
  })
};

export default HeroSupport;
